import { THEME_COLOR } from "constants/style.constants";

export function getColor(color: string) {
  if (color?.startsWith("#")) {
    return color.slice(0, 7) ?? THEME_COLOR;
  }
  return color;
}
